<template>
    <section
        class="cart-popup cart-popup__modal modal bd-example-modal-lg"
        tabindex="-1"
        role="dialog"
        data-focus="false"
        aria-labelledby="cartPopup"
        aria-hidden="true"
        ref="bootstrap_modal"
    >
        <div class="modal-dialog modal-lg">
            <div class="hidden-lg-up">
                <div class="modal-content cart-popup__modal-content">
                    <div class="cart-popup__mobile-block">
                        <div class="cart-popup__mobile-header d-flex align-items-center justify-content-between">
                            <svg class="cart-popup__mobile-header-check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>
                            <span>{{ $t("blockCart.addedToCartTitle") }}</span>
                            <div class="d-flex justify-content-center">
                                <a
                                    :href="checkoutUrl"
                                    class="cart-popup__button--cart h-100 align-items-center"
                                    id="cart-btn"
                                >
                                    <i class="fa fa-shopping-cart header__button--fa text-white" aria-hidden="true"></i>

                                    <div class="cart-popup__badge-wrapper">
                                        <div
                                            id="cart-badge--mobile"
                                            class="badge badge-small badge-pill badge-danger ajax_cart_quantity badge-small hidden"
                                        >
                                            <span>{{ cartTotalProductsCount }}</span>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="cart-popup__mobile-body">
                            <div class="row px-4 py-3" v-if="latestAddedProduct">
                                <div class="col-12 px-4">
                                    <span><strong>{{ $t("blockCart.addedToCartChoiceTitle") }}</strong></span>
                                    <div>
                                        {{ latestAddedProduct.name }}
                                    </div>
                                    <div>
                                        {{ latestAddedProduct.attributes }}
                                    </div>
                                </div>
                            </div>
                            <div class="row cart-popup__mobile-footer px-4 py-3">
                                <div class="d-flex align-items-center px-4 ">
                                    <button
                                        @click="showBlockCart = false"
                                        class="cart-popup__close-button cart-popup__close-button--mobile"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor" d="M443.8 330.8C440.6 334.3 436.3 336 432 336c-3.891 0-7.781-1.406-10.86-4.25L224 149.8l-197.1 181.1c-6.5 6-16.64 5.625-22.61-.9062c-6-6.5-5.594-16.59 .8906-22.59l208-192c6.156-5.688 15.56-5.688 21.72 0l208 192C449.3 314.3 449.8 324.3 443.8 330.8z"/>
                                        </svg>
                                    </button>
                                </div>
                                <div class="col pl-4">
                                    <a
                                        :href="checkoutUrl"
                                        class="cart-modal__checkout button button--yellow button--icon-right w-100 cart-popup__checkout-button"
                                        :title="$t('blockCart.proceedToCheckout')"
                                    >
                                        <div></div>
                                        <span>{{ $t("blockCart.proceedToCheckout") }}</span>
                                        <i class="far fa-chevron-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div
                            class="cart-popup__mobile-loading-animation"
                            v-animation-end="mobileProgressBarOnFinish"
                        ></div>
                    </div>
                </div>
            </div>
            <div class="hidden-md-down">
                <div class="modal-content modal-content--white">
                    <div class="cart-popup__desktop-block">
                        <div class="cart-popup__product">
                            <div class="cart-popup__product__wrapper">
                                <div class="cart-popup__title">
                                        <h3>{{ $t("blockCart.addedToCartTitle") }}</h3>
                                        <button
                                            @click="showBlockCart = false"
                                            class="cart-modal__back button--clear cursor-pointer"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                                <path d="M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6l-132.7 132.7c-6.253 6.253-16.37 6.253-22.63 0c-6.253-6.253-6.253-16.37 0-22.63L137.4 256L4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63c6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0c6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7C321.6 394.9 321.6 405.1 315.3 411.3z"/>
                                            </svg>
                                            <span>{{ $t("blockCart.close") }}</span>
                                        </button>
                                </div>
                                <block-cart-item
                                    v-if="latestAddedProduct"
                                    :product="latestAddedProduct"
                                ></block-cart-item>
                                <block-cart-item
                                    v-for="(cartProduct, cartProductIndex) in limitedOtherProductsInCart"
                                    :product="cartProduct"
                                    :key="cartProductIndex"
                                ></block-cart-item>

                                <div
                                    v-if="otherProductsInCart.length > limitedOtherProductsInCart.length"
                                    class="col-12 cart-popup__item"
                                >
                                    <div class="row no-gutters">
                                        <div class="cart-popup__product-count">
                                                    <span>
                                                        + {{
                                                            otherProductsInCart.length - limitedOtherProductsInCart.length
                                                        }}
                                                    </span>
                                        </div>
                                        <div class="col pl-4 d-flex align-items-center">
                                            <a
                                                class="cart-popup__products-overview-button"
                                                :href="checkoutUrl"
                                                :title="$t('blockCart.showAllProducts')"
                                            >
                                                {{ $t("blockCart.showAllProducts") }}
                                                <i class="far fa-chevron-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="cart-popup__summary">
                            <div class="cart-popup__summary__wrapper row">
                                <div class="cart-popup__summary-list col-12">
                                    <div class="cart-popup__summary-list__item cart-popup__summary-list_item--shipping">
                                        <div class="cart-popup__key">{{ $t("blockCart.cartShipping") }}:</div>
                                        <div class="cart-popup__value cart-popup__value--small">{{ shippingCost }}</div>
                                    </div>
                                    <div class="cart-popup__summary-list__item cart-popup__summary-list__item--total">
                                        <div class="cart-popup__key">{{ $t("blockCart.cartTotal") }}:</div>
                                        <div class="cart-popup__value">{{ cartTotal }}</div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="row no-gutters d-flex align-items-center">
                                        <button
                                            @click="showBlockCart = false"
                                            class="cart-modal__back d-flex button--clear cart-popup__close-button"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                                <path d="M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6l-132.7 132.7c-6.253 6.253-16.37 6.253-22.63 0c-6.253-6.253-6.253-16.37 0-22.63L137.4 256L4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63c6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0c6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7C321.6 394.9 321.6 405.1 315.3 411.3z"/>
                                            </svg>
                                        </button>
                                        <div class="col pl-4">
                                            <a
                                                :href="checkoutUrl"
                                                class="cart-modal__checkout button button--yellow button--icon-right w-100 cart-popup__checkout-button"
                                                :title="$t('blockCart.proceedToCheckout')"
                                            >
                                                <div></div>
                                                <span>{{ $t("blockCart.proceedToCheckout") }}</span>
                                                <i class="far fa-chevron-right"></i>
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import BlockCartItem from "./BlockCartItem";

export default {
    name: 'BlockCart',
    components: { BlockCartItem },
    props: {
        checkoutUrl: {
            required: true,
            type: String,
        }
    },
    data() {
        return {
            showBlockCart: false,
            latestAddedProduct: null,
            allProducts: [],
            shippingCost: null,
            cartTotal: null,
            cartTotalProductsCount: null,
            latestAddedProductPanelIsOpen: true
        }
    },
    computed: {
        otherProductsInCart() {
            if (! this.latestAddedProduct) {
                return this.allProducts;
            }

            return this.allProducts.filter((product) => {
                if (product.id !== this.latestAddedProduct.id) {
                    return true
                }
                if (product.idCombination !== this.latestAddedProduct.idCombination) {
                    return true
                }

                return false;
            });
        },
        limitedOtherProductsInCart() {
            const productLimit = this.latestAddedProduct ? 3 : 4;

            return this.otherProductsInCart.filter((product, index) => index < productLimit);
        }
    },
    watch: {
        showBlockCart(shouldShow) {
            if (shouldShow) {
                document.body.classList.add('cart-popup__modal--disable-jump');
            } else {
                document.body.classList.remove('cart-popup__modal--disable-jump');
            }

            $('.cart-popup').modal(shouldShow ? 'show' : 'hide');
            $('#js_blockcart').css('z-index', shouldShow ? '999999' : '-999999');

            if (shouldShow) {
                $('.js_hide_blockcart').click((event) => {
                    if (event.target.classList.contains('js_hide_blockcart')) {
                        this.showBlockCart = false;
                    }
                });
            }
        }
    },
    mounted() {
        const blockCartVueApp = this;

        window.EventBus.$on('block-cart-update', (blockCartData) => {
            blockCartVueApp.allProducts            = blockCartData.allProducts;
            blockCartVueApp.shippingCost           = blockCartData.cartData.shippingCost;
            blockCartVueApp.cartTotal              = blockCartData.cartData.total;
            blockCartVueApp.cartTotalProductsCount = blockCartData.cartData.nbTotalProducts;

            if (blockCartData.addedProduct) {
                blockCartVueApp.latestAddedProduct = blockCartData.addedProduct;
            }

            if (! blockCartData.addedProduct && blockCartVueApp.latestAddedProduct) {
                const latestAddedProductInCart = blockCartData.allProducts.find((product) =>
                    Number(product.id) === Number(blockCartVueApp.latestAddedProduct.id) &&
                    Number(product.idCombination) === Number(blockCartVueApp.latestAddedProduct.idCombination)
                );

                if (! latestAddedProductInCart) {
                    blockCartVueApp.latestAddedProduct = null;
                }
            }

            if (blockCartData.openCartModal) {
                blockCartVueApp.showBlockCart = true;
            }

            if (! blockCartVueApp.allProducts.length) {
                blockCartVueApp.showBlockCart = false;
            }
        });

        $('.cart-popup').on('show.bs.modal', () => {
            this.showBlockCart = true;
        });

        $('.cart-popup').on('hide.bs.modal', () => {
            this.showBlockCart = false;
        });
    },
    methods: {
        mobileProgressBarOnFinish() {
            this.showBlockCart = false;
            this.latestAddedProductPanelIsOpen = true;
        }
    },
    directives: {
        animationEnd: {
            mounted: function (el, { value }) {
                el.addEventListener('animationend', value);
            }
        }
    }
}
</script>
